import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  static targets = ["options", "aiButton", "assessmentButton", "status"];
  static values = {
    companyHasAssessment: Boolean,
    jobHasAssessment: Boolean,
    companyId: String,
    companyName: String,
    jobId: String,
    ocaiAiPath: String,
    ocaiManualPath: String,
    personaAiPath: String,
    personaManualPath: String,
    personaGrowyxPath: String,
  };

  toggle(event) {
    const isChecked = event.target.checked;
    const switchClass = event.target.className;
    const isMatchmakingSwitch = switchClass.includes("flex_switch_matchmaking");

    if (isMatchmakingSwitch) {
      this.optionsTarget.classList.toggle("d-none", !isChecked);
    }

    this.handleMutualExclusion(event.target);
  }

  handleMutualExclusion(toggledSwitch) {
    const switchClass = toggledSwitch.className;
    const isMatchmakingSwitch = switchClass.includes("flex_switch_matchmaking");
    const isPersonalitySwitch = switchClass.includes(
      "flex_switch_personality_assessment"
    );
    const isAiAnalysisSwitch = switchClass.includes("flex_switch_ai_analysis");

    if (isMatchmakingSwitch && toggledSwitch.checked) {
      this.deactivateOtherSwitches([
        "flex_switch_personality_assessment",
        "flex_switch_ai_analysis",
      ]);
    }

    if ((isPersonalitySwitch || isAiAnalysisSwitch) && toggledSwitch.checked) {
      this.deactivateOtherSwitches(["flex_switch_matchmaking"]);
    }
  }

  deactivateOtherSwitches(switchClassesToDeactivate) {
    switchClassesToDeactivate.forEach((switchClass) => {
      const switchElement = document.querySelector(`.${switchClass}`);
      if (switchElement && switchElement.checked) {
        switchElement.checked = false;

        const labelId = switchElement.dataset.target;
        const label = document.getElementById(labelId);
        if (label) {
          label.textContent = label.dataset.optional || "Inativo";
        }

        if (switchClass === "flex_switch_matchmaking") {
          this.optionsTarget.classList.add("d-none");
        }

        switchElement.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  openMatchmakingModal(event) {
    event.preventDefault();

    const modal = new bootstrap.Modal(
      document.getElementById("matchmakingModal")
    );
    modal.show();
  }

  async handleCreatePersonaWithAI() {
    const quizDone = [];
    const disc = document.getElementById("disc_option");
    const ocai = document.getElementById("ocai_option");
    const moving = document.getElementById("moving_option");

    disc.disabled = true;
    ocai.disabled = true;
    moving.disabled = true;

    if (disc.checked) quizDone.push("DISC");
    if (ocai.checked) quizDone.push("OCAI");
    if (moving.checked) quizDone.push("MOTIVATORS");

    await this.createPersonaWithAI({ quiz_done: quizDone });

    bootstrap.Modal.getInstance(
      document.getElementById("matchmakingModal")
    ).hide();
  }

  createOcaiWithAI(event) {
    event.preventDefault();

    this.postTo(this.ocaiAiPathValue, {
      company_id: this.companyIdValue,
      job_id: this.jobIdValue,
    });

    event.currentTarget.classList.toggle("disabled");
    event.currentTarget.innerHTML =
      "<i class='fa-solid fa-robot me-2'></i> AI is working...";
  }

  createOcaiManually() {
    this.postTo(this.ocaiManualPathValue);
  }

  async createPersonaWithAI(options) {
    event.preventDefault();
    event.currentTarget.classList.toggle("disabled");
    event.currentTarget.innerHTML =
      "<i class='fa-solid fa-robot me-2'></i> AI is working...";

    await this.postTo(this.personaAiPathValue, {
      job_id: this.jobIdValue,
      ...options,
    });
  }

  createPersonaManually() {
    event.preventDefault();

    post(this.personaManualPathValue, {
      body: JSON.stringify({ job_id: this.jobIdValue }),
      headers: {
        "Turbo-Frame": "false",
      },
    }).then(async (response) => {
      if (response.ok) {
        const data = await response.json;

        if (data.redirect_to) {
          Turbo.visit(data.redirect_to);
        }
      }
    });

    event.currentTarget.classList.toggle("disabled");
    event.currentTarget.innerHTML =
      "<i class='fa-solid fa-robot me-2'></i> Redirecting...";
  }

  async postTo(url, body = {}) {
    await post(url, {
      responseKind: "turbo-stream",
      body: JSON.stringify(body),
    });
  }
}
